var exports = {
  "kL": "x2b2fbebb--6bb947--container",
  "UU": "x2b2fbebb--6bb947--name",
  "pq": "x2b2fbebb--6bb947--info",
  "uf": "x2b2fbebb--6bb947--stars",
};

module.exports = exports;
